import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import socketIOClient from "socket.io-client";
import { StatusProgressBar } from "@components/molecules/StatusProgressBar";
import { Status } from "@components/templates";
import { OrderStatus } from "@globalTypes/globalTypes";
import { useOrderByTokenStatusPage } from "@saleor/sdk";
import { STATUS_STEPS } from "@temp/core/config";
import { StatusArrived, StatusCanceledSent, StatusDraft, StatusFulfilled, StatusPending, StatusSent, StatusScheduled, StatusTimeOut, StatusCanceled, StatusDelivered, StatusUnDelivered } from "@components/organisms";
import { baseUrl } from "@temp/app/routes";
import { MainMenu } from "../../../components";
import { apiUrl, websocketHost } from "../../../constants";

var getStatusProgress = function getStatusProgress(loaded, activeStepIndex, steps, status) {
  var _OrderStatus$PENDING, _OrderStatus$REFUSED_, _OrderStatus$DRAFT, _OrderStatus$FULFILLE, _OrderStatus$SENT, _OrderStatus$CANCELED, _OrderStatus$ARRIVED, _OrderStatus$SCHEDULE;

  return loaded && (((_OrderStatus$PENDING = OrderStatus.PENDING) === null || _OrderStatus$PENDING === void 0 ? void 0 : _OrderStatus$PENDING.toUpperCase()) === (status === null || status === void 0 ? void 0 : status.toUpperCase()) || ((_OrderStatus$REFUSED_ = OrderStatus.REFUSED_PAYMENT) === null || _OrderStatus$REFUSED_ === void 0 ? void 0 : _OrderStatus$REFUSED_.toUpperCase()) === (status === null || status === void 0 ? void 0 : status.toUpperCase()) || ((_OrderStatus$DRAFT = OrderStatus.DRAFT) === null || _OrderStatus$DRAFT === void 0 ? void 0 : _OrderStatus$DRAFT.toUpperCase()) === (status === null || status === void 0 ? void 0 : status.toUpperCase()) || ((_OrderStatus$FULFILLE = OrderStatus.FULFILLED) === null || _OrderStatus$FULFILLE === void 0 ? void 0 : _OrderStatus$FULFILLE.toUpperCase()) === (status === null || status === void 0 ? void 0 : status.toUpperCase()) || ((_OrderStatus$SENT = OrderStatus.SENT) === null || _OrderStatus$SENT === void 0 ? void 0 : _OrderStatus$SENT.toUpperCase()) === (status === null || status === void 0 ? void 0 : status.toUpperCase()) || ((_OrderStatus$CANCELED = OrderStatus.CANCELED_FULFILLMENT) === null || _OrderStatus$CANCELED === void 0 ? void 0 : _OrderStatus$CANCELED.toUpperCase()) === (status === null || status === void 0 ? void 0 : status.toUpperCase()) || ((_OrderStatus$ARRIVED = OrderStatus.ARRIVED) === null || _OrderStatus$ARRIVED === void 0 ? void 0 : _OrderStatus$ARRIVED.toUpperCase()) === (status === null || status === void 0 ? void 0 : status.toUpperCase()) || ((_OrderStatus$SCHEDULE = OrderStatus.SCHEDULED) === null || _OrderStatus$SCHEDULE === void 0 ? void 0 : _OrderStatus$SCHEDULE.toUpperCase()) === (status === null || status === void 0 ? void 0 : status.toUpperCase())) ? React.createElement(StatusProgressBar, {
    steps: steps,
    activeStep: activeStepIndex
  }) : null;
};

var initialOrderData = {
  __typename: "Order",
  amountOfProducts: 0,
  cancellationReason: null,
  checkoutObservation: null,
  created: "",
  scheduledAt: null,
  lastFulfillment: null,
  id: "",
  discount: null,
  number: null,
  orderAgainNotOnlinePaymentTime: null,
  orderAgainPaidTime: null,
  payAgainOrChangePaymentTime: null,
  paymentGateway: null,
  paymentConfirmationFile: null,
  manualTransferChannelName: null,
  paymentReturnUrl: null,
  paymentStatus: "",
  paymentStatusDisplay: null,
  paymentToken: null,
  responseTime: null,
  shippingAddress: null,
  shippingPrice: null,
  status: OrderStatus.TIMEOUT,
  subtotal: null,
  token: "",
  total: null,
  trade: null,
  transactionTimeoutTime: null,
  lastTransactionKind: null,
  lastUpdatedAt: ""
};
var lastOrderRefreshingTime = new Date().getTime();
var semaphoreTime = new Date().getTime();
var lastOrderStatus = "";

var StatusPage = function StatusPage() {
  var _data$orderByToken, _data$orderByToken2, _data$orderByToken3, _data$orderByToken4, _orderData$trade, _orderData$trade2, _orderData$trade3, _orderData$status3, _orderData$status4, _orderData$status5, _orderData$status6, _orderData$status7, _orderData$status8, _orderData$status9, _orderData$status10, _orderData$status11, _orderData$status12, _orderData$status13, _orderData$status14, _orderData$status15, _orderData$status16, _orderData$status17, _orderData$status18, _orderData$status19, _orderData$status20;

  var location = useLocation();
  var navigate = useNavigate();
  var params = useParams();

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loadingState = _useState2[0],
      setLoadingState = _useState2[1];

  var _useState3 = useState(initialOrderData),
      _useState4 = _slicedToArray(_useState3, 2),
      orderData = _useState4[0],
      setOrderData = _useState4[1];

  var token = "";
  var letter = "";
  var tokenUrl = params.token || null;
  /* Identifies where the token comes from */

  if (tokenUrl && ["pending-draft", "fulfilled", "sent", "arrived", "draft", "pending", "canceled_fulfillment", "scheduled"].indexOf(tokenUrl) === -1) {
    token = tokenUrl;
    letter = tokenUrl;
    localStorage.setItem("order_token", letter);
  } else if (location.state !== undefined && location.state !== null) {
    token = location.state.token;

    if (token == null) {
      return React.createElement(Navigate, {
        to: baseUrl
      });
    }

    letter = token;
    localStorage.setItem("order_token", letter);
  } else if (localStorage.getItem("order_token") !== null && localStorage.getItem("order_token") !== "null") {
    token = localStorage.getItem("order_token");
  }

  var goBackStatus = React.useCallback(function () {
    if (localStorage.getItem("flag_basket")) {
      navigate(baseUrl);
    } else if (localStorage.getItem("flag_progress")) {
      navigate("/order-in-progress/");
    } else if (localStorage.getItem("flag_history")) {
      navigate("/order-history/");
    } else {
      navigate(baseUrl);
    }
  }, []);

  var _useSearchParams = useSearchParams(),
      _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
      searchParams = _useSearchParams2[0];

  var _useOrderByTokenStatu = useOrderByTokenStatusPage({
    hasDeliveryManData: true,
    hasLines: false,
    hasTradeTypes: true,
    token: token || "",
    paymentExternalId: searchParams.get("orderId") || null
  }, {
    fetchPolicy: "cache-and-network",
    skip: !token
  }),
      data = _useOrderByTokenStatu.data,
      loading = _useOrderByTokenStatu.loading;

  useEffect(function () {
    if (!loading && (data === null || data === void 0 ? void 0 : data.orderByToken)) {
      lastOrderRefreshingTime = new Date().getTime();
      localStorage.setItem("order_status", data.orderByToken.status);
      setOrderData(_objectSpread({}, data === null || data === void 0 ? void 0 : data.orderByToken));
      setLoadingState(false);
    }
  }, [loading, data === null || data === void 0 ? void 0 : data.orderByToken, data === null || data === void 0 ? void 0 : (_data$orderByToken = data.orderByToken) === null || _data$orderByToken === void 0 ? void 0 : _data$orderByToken.status, data === null || data === void 0 ? void 0 : (_data$orderByToken2 = data.orderByToken) === null || _data$orderByToken2 === void 0 ? void 0 : _data$orderByToken2.paymentStatus, data === null || data === void 0 ? void 0 : (_data$orderByToken3 = data.orderByToken) === null || _data$orderByToken3 === void 0 ? void 0 : _data$orderByToken3.lastTransactionKind, data === null || data === void 0 ? void 0 : (_data$orderByToken4 = data.orderByToken) === null || _data$orderByToken4 === void 0 ? void 0 : _data$orderByToken4.lastUpdatedAt]);

  var refreshOrderData = function refreshOrderData(orderToken) {
    setLoadingState(true);
    axios({
      url: apiUrl,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "JWT ".concat(localStorage.getItem("token"))
      },
      data: {
        query: "\n            query UserOrderByToken(\n              $token: UUID!,\n              $hasLines: Boolean,\n              $hasDeliveryManData: Boolean,\n              $hasTradeTypes: Boolean\n            ) {\n              orderByToken(\n                token: $token,\n                hasLines: $hasLines,\n                hasDeliveryManData: $hasDeliveryManData\n                hasTradeTypes: $hasTradeTypes\n              ) {\n                __typename\n                id\n                amountOfProducts\n                cancellationReason\n                checkoutObservation\n                created\n                status\n                scheduledAt\n                number\n                paymentGateway\n                paymentToken\n                paymentStatus\n                paymentReturnUrl\n                lastTransactionKind\n                lastUpdatedAt\n                responseTime\n                token\n                orderAgainNotOnlinePaymentTime\n                shippingAddress {\n                  __typename\n                  id\n                  lastName\n                  streetAddress1\n                  streetAddress2\n                  neighborhood {\n                    __typename\n                    id\n                    name\n                  }\n                }\n                subtotal {\n                  __typename\n                  gross {\n                    __typename\n                    amount\n                    currency\n                  }\n                  net {\n                    __typename\n                    amount\n                    currency\n                  }\n                }\n                discount {\n                  __typename\n                  amount\n                  currency\n                }\n                shippingPrice {\n                  __typename\n                  gross {\n                    __typename\n                    amount\n                    currency\n                  }\n                  net {\n                    __typename\n                    amount\n                    currency\n                  }\n                }\n                total {\n                  __typename\n                  gross {\n                    __typename\n                    amount\n                    currency\n                  }\n                  net {\n                    __typename\n                    amount\n                    currency\n                  }\n                }\n                trade {\n                  __typename\n                  logoImage {\n                    __typename\n                    alt\n                    url\n                  }\n                  tradeTypes {\n                    __typename\n                    uniqueType\n                  }\n                  name\n                  phoneNumber\n                }\n                lastFulfillment {\n                  __typename\n                  cancellationReason\n                  isExternal\n                  deliveryValidationCode\n                  externalTraking\n                  deliveryman {\n                    __typename\n                    photo {\n                      __typename\n                      alt\n                      url\n                    }\n                    firstName\n                    lastName\n                    phoneNumber\n                  }\n                }\n              }\n            }\n          ",
        variables: {
          hasDeliveryManData: true,
          hasLines: false,
          hasTradeTypes: true,
          token: orderToken
        }
      }
    }).then(function (res) {
      lastOrderRefreshingTime = new Date().getTime();
      var currentOrderStatus = localStorage.getItem("order_status");

      if (currentOrderStatus !== null && currentOrderStatus !== "null" && currentOrderStatus.toUpperCase() !== res.data.data.orderByToken.status.toUpperCase()) {
        localStorage.setItem("order_status", res.data.data.orderByToken.status);
      }

      setOrderData(function (prevOrderData) {
        var _res$data, _res$data$data;

        return _objectSpread(_objectSpread({}, prevOrderData), res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.orderByToken);
      });
      setLoadingState(false);
    }) // eslint-disable-next-line no-console
    .catch(function (err) {
      return console.log(err);
    });
  };

  useEffect(function () {
    return function () {
      token = null;
      setOrderData(initialOrderData);
    };
  }, []);
  useEffect(function () {
    lastOrderRefreshingTime = new Date().getTime();
    var socket = socketIOClient(websocketHost || "", {
      secure: false,
      query: {
        token: localStorage.getItem("token")
      }
    });
    socket.on("connect", function () {
      socket.emit("create", token);
    });
    socket.on("message", function (data) {
      if (data !== "IS_ALIVE") {
        var _jsonData$order, _jsonData$order2;

        var jsonData = JSON.parse(data);
        var currentOrderStatus = localStorage.getItem("order_status") || "";

        if (jsonData.type === "order-status-notification" && ((_jsonData$order = jsonData.order) === null || _jsonData$order === void 0 ? void 0 : _jsonData$order.token) === token && ((_jsonData$order2 = jsonData.order) === null || _jsonData$order2 === void 0 ? void 0 : _jsonData$order2.status.toUpperCase()) !== currentOrderStatus.toUpperCase()) {
          refreshOrderData(token);
          semaphoreTime = new Date().getTime();
        }
      }
    });
    socket.on("error", function () {
      if (!socket.connected) {
        socket.io.connect();
      }
    });
    var keepAliveInterval = setInterval(function () {
      if (socket.connected) {
        socket.emit("socketAlive", token);

        if (new Date().getTime() - lastOrderRefreshingTime > 120000) {
          // if order state has not changed during the last 2 minutes then refreshOrderData
          refreshOrderData(token);
          semaphoreTime = new Date().getTime();
        }
      } else {
        socket.io.connect();
        refreshOrderData(token);
        semaphoreTime = new Date().getTime();
      }
    }, 30000);

    var onReturnToPage = function onReturnToPage() {
      var currentMs = new Date().getTime();

      if (semaphoreTime + 5000 < currentMs) {
        semaphoreTime = currentMs;

        if (!socket.connected) {
          socket.io.connect();
        }

        refreshOrderData(token);
        semaphoreTime = new Date().getTime();
      }
    };

    document.addEventListener("visibilitychange", onReturnToPage); // window.addEventListener("focus", onReturnToPage);

    return function () {
      token = null;
      setOrderData(initialOrderData);
      socket.emit("remove", token);
      clearInterval(keepAliveInterval);
      document.removeEventListener("visibilitychange", onReturnToPage); // window.removeEventListener("focus", onReturnToPage);

      socket.disconnect();
    };
  }, []);

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mobileCartOpened = _useState6[0],
      setMobileCartOpened = _useState6[1];

  var steps = STATUS_STEPS;

  var getActiveStepIndex = function getActiveStepIndex() {
    var matchingStepIndex = steps.findIndex(function (_ref) {
      var _orderData$status;

      var status = _ref.status;
      var statusUpper = orderData === null || orderData === void 0 ? void 0 : (_orderData$status = orderData.status) === null || _orderData$status === void 0 ? void 0 : _orderData$status.toUpperCase();

      if (statusUpper && status) {
        return status.includes(statusUpper);
      }

      return 3;
    });
    return matchingStepIndex !== -1 ? matchingStepIndex : (steps === null || steps === void 0 ? void 0 : steps.length) - 1;
  };

  var getActiveStep = function getActiveStep() {
    return steps[getActiveStepIndex()];
  };

  var activeStep = getActiveStep();
  var activeStepIndex = getActiveStepIndex();
  useEffect(function () {
    var _orderData$status2, _orderData$paymentSta, _orderData$lastTransa, _orderData$lastTransa2;

    if (!loadingState && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status2 = orderData.status) === null || _orderData$status2 === void 0 ? void 0 : _orderData$status2.toUpperCase()) === OrderStatus.PENDING && (orderData === null || orderData === void 0 ? void 0 : (_orderData$paymentSta = orderData.paymentStatus) === null || _orderData$paymentSta === void 0 ? void 0 : _orderData$paymentSta.toLowerCase()) === "pending" && ((orderData === null || orderData === void 0 ? void 0 : (_orderData$lastTransa = orderData.lastTransactionKind) === null || _orderData$lastTransa === void 0 ? void 0 : _orderData$lastTransa.toLowerCase()) === "auth" || (orderData === null || orderData === void 0 ? void 0 : (_orderData$lastTransa2 = orderData.lastTransactionKind) === null || _orderData$lastTransa2 === void 0 ? void 0 : _orderData$lastTransa2.toLowerCase()) === "empty") && lastOrderStatus === OrderStatus.REFUSED_PAYMENT) {
      setLoadingState(true);

      if (orderData === null || orderData === void 0 ? void 0 : orderData.paymentReturnUrl) {
        window.location.href = orderData === null || orderData === void 0 ? void 0 : orderData.paymentReturnUrl;
      }
    }

    lastOrderStatus = (orderData === null || orderData === void 0 ? void 0 : orderData.status) || "";
  }, [loadingState, orderData === null || orderData === void 0 ? void 0 : orderData.status, orderData === null || orderData === void 0 ? void 0 : orderData.paymentStatus, orderData === null || orderData === void 0 ? void 0 : orderData.lastTransactionKind]);
  useEffect(function () {
    localStorage.setItem("status_page", "true");
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(MainMenu, {
    gobackStatus: true,
    goback: false,
    search: false,
    cart: false,
    cartCheckout: false,
    mobileCartOpened: mobileCartOpened,
    setMobileCartOpened: setMobileCartOpened,
    differentTradeToActual: true,
    orderStatus: orderData === null || orderData === void 0 ? void 0 : orderData.status,
    tradeName: orderData === null || orderData === void 0 ? void 0 : (_orderData$trade = orderData.trade) === null || _orderData$trade === void 0 ? void 0 : _orderData$trade.name,
    tradeLogo: orderData === null || orderData === void 0 ? void 0 : (_orderData$trade2 = orderData.trade) === null || _orderData$trade2 === void 0 ? void 0 : _orderData$trade2.logoImage,
    tradeNumber: orderData === null || orderData === void 0 ? void 0 : (_orderData$trade3 = orderData.trade) === null || _orderData$trade3 === void 0 ? void 0 : _orderData$trade3.phoneNumber,
    orderNumber: orderData === null || orderData === void 0 ? void 0 : orderData.number
  }), React.createElement(Status, {
    activeStep: activeStep.name,
    loading: loadingState,
    navigation: getStatusProgress(!loadingState, activeStepIndex, steps, orderData === null || orderData === void 0 ? void 0 : orderData.status),
    status: React.createElement(React.Fragment, null, !loadingState && ((orderData === null || orderData === void 0 ? void 0 : (_orderData$status3 = orderData.status) === null || _orderData$status3 === void 0 ? void 0 : _orderData$status3.toUpperCase()) === OrderStatus.PENDING || (orderData === null || orderData === void 0 ? void 0 : (_orderData$status4 = orderData.status) === null || _orderData$status4 === void 0 ? void 0 : _orderData$status4.toUpperCase()) === OrderStatus.REFUSED_PAYMENT) ? React.createElement(StatusPending, {
      data: orderData,
      goBack: goBackStatus
    }) : !loadingState && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status5 = orderData.status) === null || _orderData$status5 === void 0 ? void 0 : _orderData$status5.toUpperCase()) === OrderStatus.DRAFT ? React.createElement(StatusDraft, {
      data: orderData,
      goBack: goBackStatus
    }) : !loadingState && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status6 = orderData.status) === null || _orderData$status6 === void 0 ? void 0 : _orderData$status6.toUpperCase()) === OrderStatus.FULFILLED ? React.createElement(StatusFulfilled, {
      data: orderData,
      goBack: goBackStatus
    }) : !loadingState && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status7 = orderData.status) === null || _orderData$status7 === void 0 ? void 0 : _orderData$status7.toUpperCase()) === OrderStatus.SENT ? React.createElement(StatusSent, {
      data: orderData,
      goBack: goBackStatus
    }) : !loadingState && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status8 = orderData.status) === null || _orderData$status8 === void 0 ? void 0 : _orderData$status8.toUpperCase()) === OrderStatus.CANCELED_FULFILLMENT ? React.createElement(StatusCanceledSent, {
      data: orderData,
      goBack: goBackStatus
    }) : !loadingState && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status9 = orderData.status) === null || _orderData$status9 === void 0 ? void 0 : _orderData$status9.toUpperCase()) === OrderStatus.ARRIVED ? React.createElement(StatusArrived, {
      data: orderData,
      goBack: goBackStatus
    }) : !loadingState && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status10 = orderData.status) === null || _orderData$status10 === void 0 ? void 0 : _orderData$status10.toUpperCase()) === OrderStatus.SCHEDULED ? React.createElement(StatusScheduled, {
      data: orderData,
      goBack: goBackStatus
    }) : !loadingState && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status11 = orderData.status) === null || _orderData$status11 === void 0 ? void 0 : _orderData$status11.toUpperCase()) && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status12 = orderData.status) === null || _orderData$status12 === void 0 ? void 0 : _orderData$status12.toUpperCase()) === OrderStatus.TIMEOUT ? React.createElement(StatusTimeOut, {
      data: orderData,
      goBack: goBackStatus
    }) : !loadingState && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status13 = orderData.status) === null || _orderData$status13 === void 0 ? void 0 : _orderData$status13.toUpperCase()) && ((orderData === null || orderData === void 0 ? void 0 : (_orderData$status14 = orderData.status) === null || _orderData$status14 === void 0 ? void 0 : _orderData$status14.toUpperCase()) === OrderStatus.CANCELED || (orderData === null || orderData === void 0 ? void 0 : (_orderData$status15 = orderData.status) === null || _orderData$status15 === void 0 ? void 0 : _orderData$status15.toUpperCase()) === OrderStatus.CANCELLED_BY_CUSTOMER || (orderData === null || orderData === void 0 ? void 0 : (_orderData$status16 = orderData.status) === null || _orderData$status16 === void 0 ? void 0 : _orderData$status16.toUpperCase()) === OrderStatus.CANCELLED_BY_SYSTEM) ? React.createElement(StatusCanceled, {
      data: orderData,
      goBack: goBackStatus
    }) : !loadingState && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status17 = orderData.status) === null || _orderData$status17 === void 0 ? void 0 : _orderData$status17.toUpperCase()) && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status18 = orderData.status) === null || _orderData$status18 === void 0 ? void 0 : _orderData$status18.toUpperCase()) === OrderStatus.DELIVERED ? React.createElement(StatusDelivered, {
      data: orderData,
      goBack: goBackStatus
    }) : !loadingState && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status19 = orderData.status) === null || _orderData$status19 === void 0 ? void 0 : _orderData$status19.toUpperCase()) && (orderData === null || orderData === void 0 ? void 0 : (_orderData$status20 = orderData.status) === null || _orderData$status20 === void 0 ? void 0 : _orderData$status20.toUpperCase()) === OrderStatus.UNDELIVERED && React.createElement(StatusUnDelivered, {
      data: orderData,
      goBack: goBackStatus
    }))
  }));
};

export { StatusPage };